import script from "./Monitor.vue?vue&type=script&setup=true&lang=js"
export * from "./Monitor.vue?vue&type=script&setup=true&lang=js"

import "./Monitor.vue?vue&type=style&index=0&id=ca75e2c2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ca75e2c2"]])

export default __exports__